import React from "react";
import "./PartnershipCollaboration.css";
import { Helmet } from "react-helmet-async";

const title = "Partnership & Collaboration";
const pageTitle =
  "Partnership & Collaboration | Respected Solutions Investment Opportunities";
const metaDescription =
  "Partner with Respected Solutions for secure, transparent, and profitable investments. Explore short-term and long-term opportunities with trusted financial management.";

const PartnershipCollaboration = () => {
  return (
    <section className="partnership-collaboration-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="partnership-collaboration-hero-slide"
        style={{
          backgroundImage: `url(/assets/images/rs/partnership_&_colb.jpg)`,
        }}
      >
        <div className="partnership-collaboration-hero-overlay">
          <div className="partnership-collaboration-hero-content">
            <h1>{title}</h1>
            <p>Building strong, sustainable partnerships.</p>
          </div>
        </div>
      </div>

      <div className="partnership-collaboration-inner">
        <div className="partnership-collaboration-inner-content">
          <section className="partnership-collaboration-intro">
            <p>
              At Respected Solutions, we believe in building strong, sustainable
              partnerships that create value for everyone involved. As a growing
              financial services company in Lagos, we welcome investors and
              strategic partners who share our vision of driving financial
              inclusion, innovation, and long-term growth.
            </p>
            <p>
              We offer a range of short-term and long-term investment
              opportunities, tailored to meet the needs of individuals,
              institutions, and businesses. Our platforms are designed with
              transparency, security, and profitability at their core.
            </p>
          </section>

          <section className="partnership-collaboration-why">
            <h2>Why Partner with Us?</h2>
            <ul>
              <li>
                Aligned Vision – Collaborate with us to build a world-class
                financial ecosystem.
              </li>
              <li>
                Flexible Options – From short-term returns to long-term growth
                strategies.
              </li>
              <li>
                Trusted Management – Experienced team ensuring professionalism
                and accountability.
              </li>
              <li>
                Growth-Oriented – Your partnership fuels innovation, expansion,
                and long-term impact.
              </li>
            </ul>
            <p>
              At Respected Solutions & Investment Limited, we don’t just accept
              investments, we build lasting relationships with partners who want
              to grow with us. Together, we can achieve greater success.
            </p>
          </section>

          <section className="partnership-collaboration-investments">
            <h2>Investment Opportunities</h2>
            <p>
              We offer short to medium-term, asset-backed investments designed
              for individuals and institutional investors seeking secure and
              consistent returns. Our focus is on transparency, professional
              management, and reliable growth.
            </p>
            <ul>
              <li>6-Month Plan – Earn 2.1% per month (short-term stability)</li>
              <li>
                1- to 5-Year Plan – Earn 2.9% per month (long-term capital
                growth)
              </li>
            </ul>
            <p>
              These investments are designed to help you diversify your
              portfolio, protect your wealth, and take advantage of Nigeria’s
              growing financial opportunities.
            </p>
          </section>

          <section className="partnership-collaboration-register">
            <h2>Register Your Interest</h2>
            <p>
              Complete the form below to receive our investor overview, detailed
              plans, and next steps:
            </p>
            <ol>
              <li>Full Name (required)</li>
              <li>Email Address (required)</li>
              <li>Phone / WhatsApp (optional but recommended)</li>
              <li>
                Potential Investment Size (choose one):
                <ul>
                  <li>₦10m - ₦50m</li>
                  <li>₦50m - ₦200m</li>
                  <li>₦200m+</li>
                </ul>
              </li>
            </ol>
            <p>
              📩 Interested in partnering or investing with us? Reach out today
              via phone, WhatsApp, Telegram, email, or our official channels to
              explore tailored opportunities that align with your financial
              goals.
            </p>
          </section>

          <section className="partnership-collaboration-partners">
            <h2>Our Partnerships</h2>
            <p>
              To give you peace of mind and added convenience, Respected
              Solutions partners with leading insurance companies to secure
              investments, and with DHL Logistics to make sending goods,
              valuables, and documents safe and stress-free. Reach out to us at{" "}
              <span>
                <a href="mailto: info@respectedsolution.co">
                  info@respectedsolution.co
                </a>
                .
              </span>
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};

export default PartnershipCollaboration;
